import React, { useState } from 'react';
import IconVisa from './static/svg/visa_landingpage.png';
import IconMastercard from './static/svg/mastercard_landing.png';
import IconSwish from './static/svg/swish_landing.png';
import IconKlarna from './static/svg/klarna_landing.png';
import { Link as RouterLink } from 'react-router-dom';

const AccordionSection = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 0',
          background: 'none',
          border: 'none',
          color: '#fff',
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        <span style={{ fontSize: 14, fontWeight: 600, letterSpacing: '0.3px' }}>{title}</span>
        <svg
          width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="rgba(255,255,255,0.4)"
          strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          style={{
            transition: 'transform 0.25s ease',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <div style={{
        maxHeight: isOpen ? 300 : 0,
        overflow: 'hidden',
        transition: 'max-height 0.3s ease',
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          paddingBottom: 16,
        }}>
          {children}
        </div>
      </div>
    </div>
  );
};

const linkStyle = {
  color: 'rgba(255,255,255,0.45)',
  fontSize: 14,
  textDecoration: 'none',
  transition: 'color 0.15s',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  fontFamily: 'inherit',
  textAlign: 'left',
};

const BottomSectionMobile = ({ setOpenCookieBar, setCookieConsentGiven }) => {
  return (
    <footer style={{
      backgroundColor: '#161825',
      color: 'rgba(255,255,255,0.6)',
      padding: '40px 20px 32px',
    }}>
      {/* Brand */}
      <div style={{
        fontSize: 20, fontWeight: 700, color: '#fff',
        letterSpacing: '-0.3px', marginBottom: 8,
      }}>
        PosterTopia
      </div>
      <p style={{
        fontSize: 13, color: 'rgba(255,255,255,0.35)',
        lineHeight: 1.6, margin: '0 0 24px',
      }}>
        Unika posters och prints för ditt hem.
      </p>

      {/* Divider */}
      <div style={{ height: 1, background: 'rgba(255,255,255,0.08)', marginBottom: 4 }} />

      {/* Accordion sections */}
      <AccordionSection title="Om oss">
        <RouterLink to="/1-om-oss" style={linkStyle}>Om oss</RouterLink>
        <RouterLink to="/1-posters" style={linkStyle}>Posters</RouterLink>
      </AccordionSection>

      <AccordionSection title="Sociala media">
        <a href="https://www.instagram.com/postertopiase/" target="_blank" rel="noopener noreferrer" style={linkStyle}>Instagram</a>
        <a href="https://www.facebook.com/people/PosterTopia/100092724335980/" target="_blank" rel="noopener noreferrer" style={linkStyle}>Facebook</a>
        <a href="https://twitter.com/postertopia" target="_blank" rel="noopener noreferrer" style={linkStyle}>X (Twitter)</a>
      </AccordionSection>

      <AccordionSection title="Kundservice">
        <RouterLink to="/1-kontakta-oss" style={linkStyle}>Kontakta oss</RouterLink>
        <RouterLink to="/1-vanliga-fragor" style={linkStyle}>Vanliga frågor</RouterLink>
        <RouterLink to="/1-kopvillkor" style={linkStyle}>Köpvillkor</RouterLink>
        <RouterLink to="/1-leverans" style={linkStyle}>Leverans</RouterLink>
        <RouterLink to="/1-cookiepolicy" style={linkStyle}>Cookiepolicy</RouterLink>
        <RouterLink to="/1-integritetspolicy" style={linkStyle}>Integritetspolicy</RouterLink>
        <button style={linkStyle} onClick={() => setCookieConsentGiven(false)}>Hantera cookies</button>
      </AccordionSection>

      {/* Bottom */}
      <div style={{
        height: 1,
        background: 'rgba(255,255,255,0.08)',
        margin: '20px 0',
      }} />

      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 20,
        marginBottom: 20,
      }}>
        {[
          { src: IconVisa, alt: 'Visa' },
          { src: IconMastercard, alt: 'Mastercard' },
          { src: IconKlarna, alt: 'Klarna' },
          { src: IconSwish, alt: 'Swish' },
        ].map((icon, i) => (
          <img
            key={i}
            src={icon.src}
            alt={icon.alt}
            style={{
              height: 22,
              width: 'auto',
              opacity: 0.45,
              filter: 'grayscale(100%) brightness(2)',
            }}
          />
        ))}
      </div>

      <p style={{
        fontSize: 12,
        color: 'rgba(255,255,255,0.3)',
        textAlign: 'center',
        margin: 0,
      }}>
        &copy; 2026 PosterTopia AB
      </p>
    </footer>
  );
};

export default BottomSectionMobile;
